<div [formGroup]="form"
     [kalLoading]="loading"
     kalDialogContent>

    <kal-form-field>
        <kal-datepicker formControlName="DateValeur"
        label="Reprise de charge à la date du">
        </kal-datepicker>
    </kal-form-field>

    <kal-radio-group formControlName="Sur">
        <kal-radio [value]="beneficiarySelection.one">Sur un bénéficiaire</kal-radio>
        <kal-form-field class="without-label" *ngIf="!isMultiSelection">

            <app-beneficiary-picker formControlName="IdBenef">
            </app-beneficiary-picker>

        </kal-form-field>
        <span  *ngIf="!isMultiSelection && !!form.value.IdBenef" >Solde de {{balanceAmount | currency:'EUR' }}</span>
        <kal-radio [value]="beneficiarySelection.all">Sur tous les bénéficiaires</kal-radio>
    </kal-radio-group>
</div>

<div kalDialogFooter>

    <div class="gup-C-validationArea gup-O-list">

        <div class="gup-O-list__item">

            <kal-button (click)="submit()"
                        [disabled]="form.invalid || loading"
                        kalTheme="primary">
                Enregistrer
            </kal-button>

        </div>

        <div class="gup-O-list__item">

            <kal-button (click)="cancel()"
                        kalTheme="secondary">
                Fermer
            </kal-button>

        </div>

    </div>

</div>
